import PropTypes from 'prop-types';

export const ChoicePropType = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  value: PropTypes.string.isRequired,
  /**
   * Is this choice an answer? (In VIEW_SOLUTION mode)
   */
  isAnswer: PropTypes.bool,
  /**
   * Is user select this choice or not? (After ANSWERING mode)
   */
  isSelected: PropTypes.bool,
});

export const EXAM_TYPE = {
  SINGLE_SELECTION: 'MULTIPLE_CHOICE',
  MULTIPLE_SELECTION: 'MULTIPLE_SELECTION',
  FILL_IN_THE_BLANK: 'FILL_IN_THE_BLANK',
};

export const EXAM_MODE = {
  ANSWERING: 'ANSWERING',
  VIEW_RESULT: 'VIEW_RESULT',
  VIEW_SOLUTION: 'VIEW_SOLUTION',
};
